import React, { useState, ChangeEvent, KeyboardEvent } from 'react';
import { useStyles } from '../../style';
import { Grid, Typography, Box, Avatar, TextField, InputAdornment, IconButton } from '@mui/material';
import MentorShipImg from '../../../../Assets/mentorshipimg.png';
import { AppButton } from '../../../../Components/AppButton';
import KenColors from '../../../../Helpers/Themes/kenColors';
import MentorImg from '../../../../Assets/mentorshipimg.png';
import CloseIcon from '@mui/icons-material/Close';
import pinImg from '../../../../Assets/pinImg.svg';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import MenteenoDetails from '../../../../Assets/menteenodetailIcon.png';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';

interface Message {
  text: string;
  sender: 'user1' | 'user2';
  timestamp: Date;
}

const styles = {
  chatContainer: {
    width: '100%',
    height: '400px',
    display: 'flex',
    flexDirection: 'column' as const,
  },
  messagesContainer: {
    flex: 1,
    padding: '10px',
    overflowY: 'auto' as const,
  },
  message: {
    marginBottom: '10px',
    padding: '10px',
    borderRadius: '5px',
    maxWidth: '70%',
    wordWrap: 'break-word' as const,
  },
  timestamp: {
    fontSize: '10px',
    marginTop: '5px',
  },
  inputContainer: {
    display: 'flex',
    padding: '10px',
    borderTop: '1px solid #ccc',
  },
  input: {
    flex: 1,
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    marginLeft: '10px',
    padding: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: 'white',
    cursor: 'pointer',
  },
};

const MentorshipCard = (props: any) => {
  const { menteeDetails } = props;
  const navigate = useNavigate();
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [messages, setMessages] = useState<Message[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [currentUser, setCurrentUser] = useState<'user1' | 'user2'>('user1');

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSendMessage = () => {
    if (inputValue.trim()) {
      const newMessage: Message = {
        text: inputValue,
        sender: currentUser,
        timestamp: new Date(),
      };
      setMessages([...messages, newMessage]);
      setInputValue('');
      toggleUser();
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const toggleUser = () => {
    setCurrentUser(currentUser === 'user1' ? 'user2' : 'user1');
  };

  const data = [
    {
      title: 'Nupur Sharma',
      subTitle: 'Financial Analyst',
    },
    {
      title: 'Michael Thompson',
      subTitle: 'Product Designer',
    },
    {
      title: 'Jennifer Park',
      subTitle: 'Financial Analyst',
    },
    {
      title: 'Nupur Sharma',
      subTitle: 'Financial Analyst',
    },
    {
      title: 'Michael Thompson',
      subTitle: 'Product Designer',
    },
  ];

  return (
    <div>
      {menteeDetails?.length > 0 ? (
        <Grid container spacing={2}>
          {menteeDetails?.map((val: any) => {
            return (
              <Grid item xs={12} sm={12} md={12} lg={3.5} xl={3.5} className={classes.mentorShipCard} sx={{ margin: 1, marginTop: 4 }}>
                <Grid container spacing={2}>
                  <Grid item xs={3.5}>
                    <Box sx={{ height: '72px', width: '63px', borderRadius: '6.11px' }}>
                      <img src={val?.Mentee__r?.Profile_Picture_URL__c} height={'100%'} width={'100%'} />
                    </Box>
                  </Grid>
                  <Grid item xs={8.5}>
                    <Typography sx={{ textAlign: 'start', fontSize: '12px', fontWeight: 500 }}>{val.Mentee__r.Name}</Typography>
                    <Typography sx={{ textAlign: 'start', fontSize: '10.5px', fontWeight: 400 }}>{val.Mentee__r.Area_of_Interest__c}</Typography>
                    <div style={{ display: 'flex', justifyContent: 'start', marginTop: 12 }}>
                      <AppButton size="small" variant="contained" className={classes.postJobBtnsMsg} others={{ color: KenColors.kenWhite, height: '18px', borderRadius: '75px' }} onClick={handleOpen}>
                        <Typography sx={{ fontSize: '9px', fontWeight: '500' }}>Message</Typography>
                      </AppButton>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Box sx={{ marginTop: '170px' }}>
          <img src={MenteenoDetails} height={'54px'} width={'54px'} />
          <Typography sx={{ fontSize: '15px', fontWeight: 600, mt: 2.5 }}>Seems like you don’t have any mentees</Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Explore today</Typography>
          <AppButton
            size="small"
            variant="contained"
            others={{ fontSize: '12px', fontWeight: '500', padding: '12px', borderRadius: '8px', height: '36px', marginTop: '20px' }}
            onClick={() => {
              navigate(routes.mentorship);
            }}
          >
            Explore network
          </AppButton>
        </Box>
      )}
      {open && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 10,
            width: { lg: 500, xl: 500 },
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 5,
          }}
        >
          <Box sx={{ backgroundColor: '#5981FF' }}>
            <Grid container>
              <Grid item xs={10} sm={10} md={10} lg={10} xl={10} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'start', fontSize: 17 }}>
                  <Avatar alt="Remy Sharp" src={MentorImg} />
                  <Typography sx={{ ml: 2, color: 'white' }}>Nupur Sharma</Typography>
                </Box>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{ p: 2, diplay: 'flex', justifyContent: 'end', color: 'white', cursor: 'pointer' }}>
                <CloseIcon onClick={handleClose} />
              </Grid>
            </Grid>
          </Box>
          <div style={styles.chatContainer}>
            <div style={styles.messagesContainer}>
              {messages.map((message, index) => (
                <Box sx={{ display: 'flex', justifyContent: message.sender === 'user1' ? 'start' : 'end' }}>
                  <div
                    key={index}
                    style={{
                      ...styles.message,
                      alignSelf: message.sender === 'user1' ? 'flex-start' : 'flex-end',
                      backgroundColor: message.sender === 'user1' ? '#F6F8FB' : '#EAEFFF',
                      color: '#373A45',
                    }}
                  >
                    <Box>{message.text}</Box>
                  </div>
                </Box>
              ))}
            </div>
            <div style={styles.inputContainer}>
              <TextField
                variant="outlined"
                placeholder="Type here"
                value={inputValue}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                sx={{
                  backgroundColor: '#EDEEF1',
                  borderRadius: 5,
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      border: 'none',
                    },
                  },
                }}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <img src={pinImg} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <AppButton size="small" variant="contained" onClick={handleSendMessage} others={{ color: KenColors.kenBlack, borderRadius: 15, marginLeft: 10 }} background="#EDEEF1">
                <SendOutlinedIcon />
              </AppButton>
            </div>
          </div>
        </Box>
      )}
    </div>
  );
};

export default MentorshipCard;
